/**
 * @file Pluralize utility module.
 */

import pluralize from 'pluralize';

const initPluralize = () => {
  pluralize.addUncountableRule('min');
  pluralize.addUncountableRule('sec');
  pluralize.addPluralRule('hr', 'hrs');
  pluralize.addPluralRule('it', 'them');
};

export { initPluralize };
